import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.9999 1.99988C6.47988 1.99988 1.99988 6.47988 1.99988 11.9999C1.99988 17.5199 6.47988 21.9999 11.9999 21.9999C17.5199 21.9999 21.9999 17.5199 21.9999 11.9999C21.9999 6.47988 17.5199 1.99988 11.9999 1.99988ZM12.9999 16.9999H10.9999V10.9999H12.9999V16.9999ZM12.9999 8.99988H10.9999V6.99988H12.9999V8.99988Z" })
});
export default SvgInfo;
